import { Col, Row } from "../../ApiS/Grid-system/Grid-system";
import Add from "../../components/Buttons/Add";
import News_Card from "../../components/News_Card/News_Card";
import Title from "../../components/Title/Title";
import uni from "../../images/fb0bb5cd017b15aa49ee7a86a2e0c972.png";

interface AdsProps {}

const Ads: React.FC<AdsProps> = () => {
  return (
    <>
      <Row>
        <Col>
          <Title title="الاعلانات" />
        </Col>
      </Row>

      {/* <Row justify={"center"}>
        <Col lg={3} md={5} sm={11} className="mx-4 ">
          <News_Card
            image={uni}
            paragrph="إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال الفترة ما بين الأحد و الخميس"
          />
        </Col>
        <Col lg={3} md={5} sm={11} className="mx-4">
          <News_Card
            image={uni}
            paragrph="إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال الفترة ما بين الأحد و الخميس"
          />
        </Col>
        <Col lg={3} md={5} sm={11} className="mx-4">
          <News_Card
            image={uni}
            paragrph="إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال الفترة ما بين الأحد و الخميس"
          />
        </Col>
      </Row>

      <Row justify={"center"} className="!mt-4">
        <Col lg={3} md={5} sm={11} className="mx-4">
          <News_Card
            image={uni}
            paragrph="إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال الفترة ما بين الأحد و الخميس"
          />
        </Col>
        <Col lg={3} md={5} sm={11} className="mx-4">
          <News_Card
            image={uni}
            paragrph="إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال الفترة ما بين الأحد و الخميس"
          />
        </Col>
        <Col lg={3} md={5} sm={11} className="mx-4">
          <News_Card
            image={uni}
            paragrph="إجراءات المفاضلة عبر الأنترنت يمكن التقدم إلى مفاضلة التعليم المفتوح للعام الدراسي 2020/2019 عن طريق الانترنت وذلك خلال الفترة ما بين الأحد و الخميس"
          />
        </Col>
      </Row> */}

      <Add check={true} />
    </>
  );
};

export default Ads;
